import { Body, Box, Heading, Link } from '@hover/blueprint';
import React, { FC } from 'react';
import { INewsItem } from '../../interfaces/INewsItem';

const NewsItem: FC<{ item: INewsItem }> = ({ item }) => (
  <Box key={item.title} flexDir="column">
    <Body color="neutral.900" size={300}>
      {item.date}
    </Body>
    <Heading as="h3" color="neutral.900" pt={400} size={300} marginBottom={0}>
      <Link isExternal href={item.href}>
        {item.title}
      </Link>
    </Heading>
    {item.description ? (
      <Body color="neutral.900" size={500} pt={400}>
        {item.description}
      </Body>
    ) : null}
  </Box>
);

export default NewsItem;
